// BiggestDealsSection.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from './ProductCard';
import api from '../utils/api';
import { fetchAfterHero, registerShownProducts } from '../utils/feedRegistry';
import '../StylesComponents/biggest-deals-section.css';

// Products are chosen server-side from a deep-discount quality pool and the
// window rotates once per calendar day (Australia/Sydney).
function BiggestDealsSection({ currentUser }) {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        setLoading(true);
        const res = await fetchAfterHero((exclude) => api.get('/api/products', {
          params: {
            limit: 12,
            feedContext: 'biggest_deals',
            discountRanges: '70+',
            ...(exclude.length > 0 ? { exclude: exclude.join(',') } : {}),
          },
        }));
        const items = res.data.products || [];
        registerShownProducts(items);
        setDeals(items);
      } catch (e) {
        console.error('Biggest deals fetch error:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchDeals();
  }, []);

  if (!loading && deals.length === 0) return null;

  return (
    <section className="biggest-deals-section">
      <div className="biggest-deals-inner">
        <div className="biggest-deals-header">
          <h2 className="biggest-deals-title">BIGGEST DEALS TODAY</h2>
          <Link to="/all-brands?sort=DiscountHighToLow&discountRanges=70%2B" className="biggest-deals-view-all">
            SHOP ALL DEALS →
          </Link>
        </div>

        <div className="biggest-deals-row">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={`skeleton-${i}`} className="biggest-deals-card biggest-deals-card--skeleton" aria-hidden="true" />
              ))
            : deals.map((product, index) => (
                <div key={product._id || product.id || index} className="biggest-deals-card">
                  <ProductCard
                    product={product}
                    currentUser={currentUser}
                    feedSection="biggest_deals"
                    position={index}
                  />
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}

export default BiggestDealsSection;
